import moment from "moment";

export const subdomain = window.location.host.split(".")[1]
  ? window.location.host.split(".")[0]
  : "";

export const domain = "mh-camping.com";

export function dateTimeFormatterWithDay(dateTime, locale) {
  const value = moment(dateTime);

  return (locale ? value.locale(locale) : value).format(
    "dd, DD.MM.YYYY - HH:mm"
  );
}

export function dateTimeFormatter(dateTime) {
  return moment(dateTime).format("DD.MM.YYYY - HH:mm");
}

export function dateFormatter(dateTime) {
  return moment(dateTime).format("DD.MM.YYYY");
}

export function timeFormatter(dateTime) {
  return `${moment(dateTime).format("HH:mm")} Uhr`;
}

export function euroFormatter(number) {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(number);
}

export function localeOptions(configuration, locales) {
  return (
    configuration?.available_locales?.filter((available_locale) =>
      locales?.includes(available_locale.locale)
    ) ?? []
  );
}
